import PropTypes from "prop-types";
import { TextField, Box } from "@mui/material";

function LastNameField({ displayName, fieldRef, isOptional, options }) {
  // console.log(options);
  return (
    <Box>
      <TextField
        id={`dff_${fieldRef}`}
        name={fieldRef}
        margin="dense"
        label={displayName}
        type="text"
        fullWidth
        variant="outlined"
        // onBlur={(e) => {
        //   if (e.target.value === "") {
        //     return;
        //   }
        // }}
        options={options}
      />
    </Box>
  );
}

// Typechecking props of the Transaction
LastNameField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

LastNameField.defaultProps = {
  options: null,
};

export default LastNameField;
